{
  "info": "Info",
  "negative": "Fout",
  "positive": "Geslaagd"
}
